import React from 'react'
import {Accordion } from 'semantic-ui-react'
import {FaqList} from '../../docs/faq'


function Faq() {

  return (
    <div>
      <br/>
        <h1>Sıkça Sorulan Sorular</h1>
        <Accordion panels={FaqList} defaultActiveIndex={0} />
    </div>
  )
}

export default Faq
